<template>
  <ValidationObserver ref='validator' slim>
    <div v-if="gridAccessPoint" class='lib__field' data-cy='identification-confirmation-component'>
      <h3>{{ $t('identification.smartMeter.message') }}</h3>

      <ul class='lib__infobox-list'>
        <InfoBox item level='primary'>
          <template v-slot:icon>
            <img :src="require('@ores/css-library/assets/img/icons/electricity.svg')" alt='electricity' />
          </template>
          <template>
            <h3 class='lib__text-uppercase'>{{ $t('identification.smartMeter.eanCode') }}</h3>
            <p>{{ eanCode }}</p>
          </template>
        </InfoBox>
        <InfoBox item level='success'>
          <template v-slot:icon>
            <div class='lib__tooltips lib__tooltips--top-left'>
              <span>
                <i class='fas fa-map-marker-alt'></i>
              </span>
              <span class='lib__tooltips__data'>{{ $t('identification.smartMeter.addressTooltip') }}</span>
            </div>
          </template>
          <template>
            <h3 class='lib__text-uppercase'>{{ $t('identification.smartMeter.address') }}

            </h3>
            <p>{{ addressFromConsumption }} </p>
          </template>
        </InfoBox>
      </ul>

      <div class='lib__field__note'>
        <div>
          <b v-html="$t('identification.smartMeter.wrongAddressMessage')"></b>
          <button class='lib__chat_trigger lib__btn lib__btn--primary lib__btn--small' @click='openChat'><i
            class='fas fa-comments'></i></button>
        </div>
      </div>

    </div>
    <div v-else class='lib__field' data-cy='identification-confirmation-component'>
      <Feedback icon level='danger' outline simple>
        <p v-html='$t(`chargingStationDeclaration.identification.eanNotFound`)'></p>
      </Feedback>
    </div>
  </ValidationObserver>
</template>

<script lang='ts'>
import CollapseInfo from '@/components/display/CollapseInfo.vue'
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { ChargingStationDeclarationGridAccessPoint } from '@/models'
import { chatService } from '@/services'

@Component({
  components: {
    CollapseInfo
  }
})
export default class IdentificationConfirmation extends Vue {
  //#region [Props]
  @Prop({ type: String, required: true }) public readonly eanCode!: string
  @Prop({ type: Object, required: true }) public readonly gridAccessPoint!: ChargingStationDeclarationGridAccessPoint
  //#endregion

  //#region [Data]
  //#endregion

  //#region [Computed]
  private get addressFromConsumption() {
    const address = this.gridAccessPoint.consumptionAddress
    let str = address.streetName
    if (address.houseNumber) {
      str += ' ' + address.houseNumber
    }
    if (address.complement) {
      str += ' ' + address.complement
    }
    if (address.complementBox) {
      str += ' ' + address.complementBox
    }
    if (address.floorNumber) {
      str += ` (${this.$t(`identification.smartMeter.floor`).toString()}: ${address.floorNumber})`
    }
    str += ', ' + address.zipCode
    str += ' ' + address.cityName
    return str
  }

  //#endregion

  //#region [Method]
  private openChat() {
    chatService.openChat()
  }

  //#endregion
}
</script>


